import { COMMON_CONSTANTS } from "src/constants/commonConstants";
import commonUtils, { urlReplace } from "src/utils/common.utils";

import API_URL from "./apiConfig/api.config";
import handleResponse from "./apiConfig/api.response.service";
import apiCall from "./apiConfig/apiCall.config";

export async function getContactSense(uuid: string, officeUuid: string) {
  const url = commonUtils.getUrlReplace(
    commonUtils.getUrlReplace(
      API_URL.SENSE.CONTACT_SENSE,
      COMMON_CONSTANTS.OFFICE_UUID,
      officeUuid
    ),
    COMMON_CONSTANTS.CONTACT_UUID,
    uuid
  );
  return await apiCall.get(url);
}

export async function getProfessionalSense(uuid: string) {
  const url = commonUtils.getUrlReplace(
    API_URL.SENSE.PROFESSIONAL_SENSE,
    COMMON_CONSTANTS.PROFESSIONAL_UUID,
    uuid
  );
  return await apiCall.get(url);
}

export async function getProspectSense(prospectUuid: string) {
  const url = urlReplace(
    API_URL.SENSE.PROSPECT_SENSE,
    "prospectUuid",
    prospectUuid
  );
  return await apiCall.get(url);
}

export async function updateRecruiterStatus(data: {
  recruiter_status: number;
  user_uuids: string[];
}) {
  const res = await apiCall.patch(API_URL.SENSE.UPDATE_RECRUITER_STATUS, data);
  const responseData = await handleResponse(res);
  return responseData;
}

export async function updateProspectRecruiterStatus(data: {
  prospect_uuids: string[];
  recruiter_status: number;
}) {
  const res = await apiCall.patch(
    API_URL.SENSE.UPDATE_PROSPECT_RECRUITER_STATUS,
    data
  );
  const responseData = await handleResponse(res);
  return responseData;
}

export async function getRecruiterLogs(userUuid: string) {
  const url = commonUtils.getUrlReplace(
    API_URL.SENSE.GET_RECRUITER_LOGS,
    "userUuid",
    userUuid
  );
  return await apiCall.get(url);
}

export async function getProspectRecruiterLogs(prospectUuid: string) {
  const url = commonUtils.getUrlReplace(
    API_URL.SENSE.GET_PROSPECT_RECRUITER_LOGS,
    "prospectUuid",
    prospectUuid
  );
  return await apiCall.get(url);
}
